import Swiper, {Autoplay, Navigation} from 'swiper';

const initSliders = () => {
	const sliders = document.querySelectorAll('.images-slider--single');
	if (sliders.length > 0) {
		sliders.forEach((slider) => {
			const navNextButton = slider.nextElementSibling.querySelector('.slider-indicator__nav--next');
			const navPrevButton = slider.nextElementSibling.querySelector('.slider-indicator__nav--prev');
			const currentIndex = slider.nextElementSibling.querySelector('.slider-indicator__current');
			
			new Swiper(slider, {
				modules: [Autoplay, Navigation],
				spaceBetween: 0,
				slidesPerView: 1,
				loop: false,
				autoplay: 1000,
				navigation: {
					nextEl: navNextButton,
					prevEl: navPrevButton,
				},
				preventClicks: false,
				preventClicksPropagation: false,
				on: {
					activeIndexChange: function (swiper) {
						currentIndex.textContent = swiper.activeIndex + 1;
					},
				},
			});
		});
	}
	
	
	// const bannersSlider = document.querySelector('.banners-slider__swiper');
	// if (bannersSlider) {
	// 	const slidesCount = parseInt(bannersSlider.dataset.slidesCount);
	//
	// 	new Swiper('.banners-slider__swiper', {
	// 		modules: [Autoplay, Pagination],
	// 		spaceBetween: 0,
	// 		slidesPerView: 1,
	// 		loop: slidesCount > 1,
	// 		speed: 2300,
	// 		autoplay: {
	// 			delay: 3500,
	// 			disableOnInteraction: true,
	// 		},
	// 		pagination: {
	// 			el: ".swiper-pagination",
	// 			clickable: true,
	// 		},
	// 		preventClicks: false,
	// 		preventClicksPropagation: false,
	// 	});
	// }
}

export default initSliders;
